import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { unspaceString } from "@grandvisionhq/utils";
import { isValidPortugueseMobilePhoneNumber } from "../../../../../../../utils/modules/PaymentMethodsList/containers/Adyen/Mbway/utils/is-valid-portuguese-mobile-phone-number.js";
import { Mbway } from "../../../../../../../components/modules/PaymentMethodsList/containers/Adyen/Mbway/components/Mbway.js";
const MbwayContainer = ({ initialValue, onChange }) => {
  const { getLabel } = useIntl();
  const handleOnChange = React.useCallback(
    (state) => {
      onChange(
        { phoneNumber: unspaceString(state.value) },
        isValidPortugueseMobilePhoneNumber(state.value)
      );
    },
    [onChange]
  );
  const labels = React.useMemo(() => {
    return {
      hintTitle: getLabel("checkout.payment.method.mbWay.hint.title"),
      hintMessage: getLabel("checkout.payment.method.mbWay.hint.message"),
      phoneNumberLabel: getLabel("checkout.contact.phoneNumber"),
      phoneNumberPlaceholder: getLabel("checkout.payment.method.mbWay.phoneNumber.placeholder"),
      phoneNumberError: getLabel("checkout.contact.phoneNumber.errorMessage"),
      info: getLabel("checkout.payment.method.mbWay.info")
    };
  }, [getLabel]);
  return /* @__PURE__ */ React.createElement(
    Mbway,
    {
      initialValue,
      labels,
      onChange: handleOnChange,
      validations: [isValidPortugueseMobilePhoneNumber]
    }
  );
};
export {
  MbwayContainer
};
//# sourceMappingURL=MbwayContainer.js.map
